const RECENT_ITEMS_KEY = 'recentlyWatched';
const ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds

export const saveToRecentCache = (item, season = null, episode = null) => {
  try {
    const existingData = localStorage.getItem(RECENT_ITEMS_KEY);
    let recentItems = [];
    
    if (existingData) {
      const parsed = JSON.parse(existingData);
      recentItems = parsed.filter(cachedItem => {
        return Date.now() - cachedItem.timestamp < ONE_WEEK_MS;
      });
    }
    
    const existingIndex = recentItems.findIndex(cachedItem => 
      cachedItem.data.id === item.id && cachedItem.data.media_type === item.media_type
    );
    
    const newItem = {
      data: {
        ...item,
        currentSeason: season !== null ? season : (item.currentSeason || 1),
        currentEpisode: episode !== null ? episode : (item.currentEpisode || 1)
      },
      timestamp: Date.now()
    };
    
    if (existingIndex !== -1) {
      recentItems[existingIndex] = newItem;
    } else {
      recentItems.unshift(newItem);
    }
    
    recentItems = recentItems.slice(0, 50);
    localStorage.setItem(RECENT_ITEMS_KEY, JSON.stringify(recentItems));
  } catch (error) {
    console.error('Error saving to recent cache:', error);
  }
};

export const getRecentFromCache = () => {
  try {
    const existingData = localStorage.getItem(RECENT_ITEMS_KEY);
    if (!existingData) return [];
    
    const parsed = JSON.parse(existingData);
    const validItems = parsed.filter(cachedItem => {
      return Date.now() - cachedItem.timestamp < ONE_WEEK_MS;
    });
    
    if (validItems.length !== parsed.length) {
      localStorage.setItem(RECENT_ITEMS_KEY, JSON.stringify(validItems));
    }
    
    return validItems
      .sort((a, b) => b.timestamp - a.timestamp)
      .map(item => item.data);
      
  } catch (error) {
    console.error('Error getting recent from cache:', error);
    return [];
  }
};

export const clearRecentCache = () => {
  try {
    localStorage.removeItem(RECENT_ITEMS_KEY);
  } catch (error) {
    console.error('Error clearing recent cache:', error);
  }
};

export const removeFromRecentCache = (itemId, mediaType) => {
  try {
    const existingData = localStorage.getItem(RECENT_ITEMS_KEY);
    if (!existingData) return;
    
    const parsed = JSON.parse(existingData);
    const filteredItems = parsed.filter(cachedItem => 
      !(cachedItem.data.id === itemId && cachedItem.data.media_type === mediaType)
    );
    
    localStorage.setItem(RECENT_ITEMS_KEY, JSON.stringify(filteredItems));
  } catch (error) {
    console.error('Error removing from recent cache:', error);
  }
};